import { timeAgo } from '../../utils/utils';
import type { KiaRequestSnapshot } from '../../models/kia-request/kia-request';
// import type * as Types from '../api/api.types';

const convertQA = (item: any): {id:number, autoGenerated: boolean,
    question: string,
    answer: string,
    timeTaken: number} => {

        return {
            id: item.id,
            autoGenerated: item.auto_generated == 1,
            question: item.question,
            answer:item.answer,
            timeTaken: item.time_taken            
        }
}

const convertResponse = (item: any) => {
    if(item.response){
        if(item.response.qa && item.response.qa.length>0){
            var qa = item.response.qa.map(convertQA);
        }
        return {
            id: item.response.id,
            longText:item.response.long_text || "",
            summary: item.response.summary || "",
            title: item.response.title || "",
            uri: item.response.uri || "",
            createdDate: timeAgo(item.response.created_at),
            qa: qa || [],            
        }
        
    }else{
        return {
            id: 0,
            longText: "",
            summary: "",
            title: "",
            uri: "",
            createdDate: "",
            qa: []
        }
    }
}

const convertRequestParams = (item: any) => {
    const requestJSON = JSON.parse(item.request_json);
    return {
        url: requestJSON.url || "",
        longText: requestJSON.longText || "",
        summaryType: requestJSON.summary_type || "",
        jobs: requestJSON.jobs || []
    }
}

const convertRequest = (item: any, overrideBookmarked=false):KiaRequestSnapshot => { 
    console.log("item");
    overrideBookmarked === true && console.log(item);
    return {
        id: item.id,
        error: item.error || undefined, //to-do: error management
        isGlobal: item.is_global == 1,
        response: convertResponse(item),
        requestParams: convertRequestParams(item),
        createdDate: timeAgo(item.created_at),
        bookmarked: overrideBookmarked===true ? true : (item.bookmarks_count && item.bookmarks_count > 0) ? true : false
    }
}

export const paginatedRequestTransformer = (response: any):KiaRequestSnapshot[] => {
    if(response.data){
        if(response.data.data){ 
            return response.data.data.map(convertRequest);                       
        }
    }    
    return [];
}

export const singleRequestTransformer = (response: any): KiaRequestSnapshot => {    
    return convertRequest(response.data);    
}

export const bookmarkedRequestTransformer = (response: any):KiaRequestSnapshot[] => {
    console.log("bookmarks");
    console.log(response);
    if(response.data){
        console.log("yes data");
        if(response.data.data){
            console.log("yes data 2");
            return response.data.data.map((item => convertRequest(item.request, true)))
        }
    }
    return [];
}

export const createRequestPreTransformer = (title: string, method:string, longText: string|null, link:string|null, summaryType:string|undefined, jobS:boolean, jobQA:boolean, jobGenQA:boolean, questions:Array<{}>, is_global:boolean) => {
    var res: {[k: string]: any} = {title: title, is_global:is_global?1:0};
    
    method === "text" ?        
        res.longText = longText :
        res.url = link;

    if(jobS) res.summary_type = summaryType || "tight";
    
    if(jobQA && questions && questions.length > 0){
        res.questions = questions;
    }else{
        jobQA = false;
    }

    var processes: Array<string> = [];
    jobS && processes.push("summary");
    jobQA && processes.push("qa");
    jobGenQA && processes.push("gen_qa");
    res.jobs = processes;
    return res;
}